import safelyIncrement from '../../helpers/safelyIncrement';

export default (state, action) => {
  const { containerCount, itemCount } = state;
  const { designId, container } = action.payload;

  const updatedContCount = {
    ...containerCount,
    [designId]: safelyIncrement(containerCount[designId]),
  };

  const updatedItemCount = {
    ...itemCount,
    [container.containerId]: 1,
  };

  return {
    ...state,
    containerCount: updatedContCount,
    itemCount: updatedItemCount,
  };
};
